import { useContext, useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import MultiTab from "src/components/MultiTab";
import Tab from "src/components/MultiTab/Tab";
import Modal from "src/components/Modal";
import ModalHeader from "src/components/Modal/ModalHeader";
import ModalBody from "src/components/Modal/ModalBody";
import ModalFooter from "src/components/Modal/ModalFooter";
import TwinButton from "src/components/TwinButton";
import Inbound from "./components/Inbound";
import { notify } from "src/services/Notification/Notification";
import { post } from "src/services/HttpClient";
import { useNavigate } from "react-router-dom";
import userContext from "src/context/userContext";

export default function SellerOrders() {

    const { user } = useContext(userContext);

    const [DueTodayAndPast, setDueTodayAndPast] = useState([]);
    const [DueFuture, setDueFuture] = useState([]);

    const [selectedInbound, setSelectedInbound] = useState();
    const [inbound, setInbound] = useState();

    const [sellerComment, setSellerComment] = useState("");
    const [userComment, setUserComment] = useState("");

    const [isInboundModalOpen, setIsInboundModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    /**
     * دریافت تعهدات ارسال
     */
    const fetchDeliveryCommitments = async () => {

        if (!user?.email) return;

        setLoading(true);

        try {

            const res = await getData(
                () => { },
                "/sellers/delivery-commitments"
            );

            const data = res;

            setDueTodayAndPast(
                data?.dueTodayAndPast || []
            );

            setDueFuture(
                data?.dueFuture || []
            );

        } catch (error) {

            console.error(error);

            notify(
                "خطا در دریافت اطلاعات",
                "error"
            );

        } finally {

            setLoading(false);
        }
    };

    /**
     * دریافت اولیه دیتا
     */
    useEffect(() => {

        fetchDeliveryCommitments();

    }, [user?.email]);

    /**
     * وقتی محصولات انتخاب میشن
     */
    useEffect(() => {

        if (
            selectedInbound &&
            selectedInbound?.rows &&
            selectedInbound?.rows.length
        ) {

            setInbound(
                selectedInbound.rows.map((row) => ({
                    ...row.original,
                    deliveryQuantity:
                        row.original.totalQuantity ??
                        row.original.inboundQuantity
                }))
            );

        } else {

            setInbound(null);
        }

    }, [selectedInbound]);

    /**
     * تولید خودکار متن کسری
     */
    useEffect(() => {

        if (!inbound) return;

        const deficitTexts = inbound
            .map(item => {

                const totalQty =
                    item.totalQuantity ??
                    item.inboundQuantity;

                const delivered =
                    item.deliveryQuantity ??
                    totalQty;

                const deficit =
                    totalQty - delivered;

                if (deficit > 0) {

                    return `محصول ${item.name} (${item.sku}) به تعداد ${deficit} عدد کسری دارد.`;
                }

                return null;
            })
            .filter(Boolean);

        setSellerComment(
            deficitTexts.join(" ")
        );

    }, [inbound]);

    /**
     * ساخت محموله
     */
    const submitInbound = async () => {

        if (!inbound || inbound.length === 0) {

            notify(
                "هیچ محصولی برای ارسال انتخاب نشده است",
                "warning"
            );

            return;
        }

        setLoading(true);

        try {

            const products = [];

            for (const item of inbound) {

                const totalDeliverable =
                    Number(item.deliveryQuantity || 0);

                if (totalDeliverable <= 0) {
                    continue;
                }

                let remain = totalDeliverable;

                for (const order of (item.orderIds || [])) {

                    if (remain <= 0) {
                        break;
                    }

                    const orderQty =
                        Number(order.quantity || 0);

                    // مقدار واقعی قابل ارسال
                    const inboundQuantity =
                        Math.min(remain, orderQty);

                    if (inboundQuantity <= 0) {
                        continue;
                    }

                    products.push({

                        productId:
                            Number(item.product_id),

                        orderId:
                            String(order.id),

                        orderQuantity:
                            orderQty,

                        inboundQuantity,

                        deliveredQuantity: 0
                    });

                    remain -= inboundQuantity;
                }
            }

            if (products.length === 0) {

                notify(
                    "هیچ محصول معتبری برای ارسال وجود ندارد",
                    "warning"
                );

                return;
            }

            const payload = {

                sellerComment:
                    [
                        sellerComment,
                        userComment
                    ]
                        .filter(Boolean)
                        .join("\n"),

                products
            };

            const result = await post(
                "/inbounds/seller",
                payload
            );

            if (
                result?.statusCode === 200 ||
                result?.statusCode === 201 ||
                result?.data?.statusCode === 201
            ) {

                notify(
                    "محموله با موفقیت ایجاد شد",
                    "success"
                );

                // reset states
                setIsInboundModalOpen(false);

                setSelectedInbound(null);

                setInbound(null);

                setSellerComment("");

                setUserComment("");

                // refresh data
                await fetchDeliveryCommitments();

                navigate(
                    "/app/warehouse-management/seller-inbound"
                );

            } else {

                notify(
                    result?.message ||
                    "خطا در ایجاد محموله",
                    "error"
                );
            }

        } catch (error) {

            console.error(
                "Submit inbound error:",
                error
            );

            notify(
                "خطا در ارتباط با سرور",
                "error"
            );

        } finally {

            setLoading(false);
        }
    };

    /**
     * ستون های جدول
     */
    const columns = [
        {
            id: "image",
            cell: (info) => (
                <img
                    className="w-[80px] max-w-[80px] rounded-lg object-cover"
                    src={`${process.env.REACT_APP_CDN_URL}/thumbnail/${info.row.original.product_id}/${info.getValue()}`}
                    alt="product"
                />
            ),
            header: "تصویر",
            inExport: false
        },

        {
            id: "name",
            cell: (info) =>
                info.getValue()
                    ? info.getValue()
                    : "---",

            header: "نام محصول",
        },

        {
            id: "sku",
            cell: (info) =>
                info.getValue()
                    ? info.getValue()
                    : "---",
            header: "SKU",
        },

        {
            id: "orderIds",
            cell: (info) => {
                const orders =
                    info.getValue();
                if (
                    orders &&
                    orders.length
                ) {
                    return (
                        <div className="flex flex-col gap-1">
                            {
                                orders.map((order, idx) => (
                                    <span
                                        key={idx}
                                        className="text-sm"
                                    >
                                        #{order.id}
                                        {" "}
                                        (تعداد:
                                        {" "}
                                        {order.quantity})
                                    </span>
                                ))
                            }
                        </div>
                    );
                }
                return "---";
            },
            header: "شماره سفارش",
        },
        {
            id: "totalQuantity",

            cell: (info) =>

                info.getValue()
                    ? (
                        <span className="text-lg font-bold text-blue-600">
                            {info.getValue()}
                        </span>
                    )
                    : "---",

            header: "تعداد فروش",
        },
    ];

    return (
        <>

            <PageHeader
                title="لیست سفارشات"
                btnTitle={
                    selectedInbound?.rows?.length
                        ? "ایجاد محموله"
                        : false
                }
                handleClick={() => {
                    setIsInboundModalOpen(true);
                }}
            />

            {
                loading && (
                    <div className="flex justify-center items-center py-10">
                        <div className="loader">
                            در حال بارگذاری...
                        </div>
                    </div>
                )
            }

            <MultiTab type={4}>
                <Tab
                    title="تعهد ارسال امروز و گذشته"
                    activeTab
                >
                    <Table
                        columns={columns}
                        data={DueTodayAndPast}
                        CSVExportPermission="viewDashboard"
                        tableName="DueTodayAndPast"
                        isSelective
                        setSelected={setSelectedInbound}
                        tablePerPage={100}
                    />
                </Tab>
                <Tab title="تعهد ارسال فردا و آینده">
                    <Table
                        columns={columns}
                        data={DueFuture}
                        CSVExportPermission="viewDashboard"
                        tableName="DueFuture"
                        isSelective
                        setSelected={setSelectedInbound}
                        tablePerPage={100}
                    />
                </Tab>
            </MultiTab>

            <Modal
                isOpen={isInboundModalOpen}
                width={1200}
            >

                <ModalHeader>
                    ایجاد محموله انبار
                </ModalHeader>

                <ModalBody>
                    <div className="p-4">
                        <Inbound
                            inbound={inbound}
                            setInbound={setInbound}
                        />
                        <div className="flex flex-col gap-1 mt-2">
                            <label htmlFor="sellerComment">
                                توضیحات فروشنده
                            </label>
                            <textarea
                                id="sellerComment"
                                className="rounded-xl p-2 bg-white border border-gray-200"
                                rows="4"
                                value={
                                    sellerComment +
                                    (
                                        userComment
                                            ? "\n" + userComment
                                            : ""
                                    )
                                }
                                onChange={(e) => {
                                    const prefixLength =
                                        sellerComment.length;
                                    let inputText =
                                        e.target.value;
                                    // جلوگیری از حذف متن خودکار
                                    if (
                                        !inputText.startsWith(
                                            sellerComment
                                        )
                                    ) {
                                        inputText =
                                            sellerComment +
                                            inputText.slice(
                                                prefixLength
                                            );
                                    }
                                    const newUserComment =
                                        inputText
                                            .slice(
                                                sellerComment.length
                                            )
                                            .trimStart();
                                    setUserComment(
                                        newUserComment
                                    );
                                }}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle="ساخت و ایجاد محموله"
                        rejectTitle="لغو"
                        rejectHandle={() => {
                            setIsInboundModalOpen(false);
                            setSelectedInbound(null);
                            setSellerComment("");
                            setUserComment("");
                            setInbound(null);
                        }}
                        acceptHandle={() => {
                            submitInbound();
                        }}
                        isCompact
                    />
                </ModalFooter>
            </Modal>
        </>
    );
}